<script>
    import { SendRequest } from "./APIService";
    import { showModal } from "./Modal";

    let userIdToBan = "";
    let bannedUsers = [];

    const banUser = () => {
        const id = userIdToBan.trim();
        if (!id) {
            showModal("Error", "Please enter a User ID", "OK");
            return;
        }
        SendRequest("ReconnectBanUser", "POST", "userId=" + id, () => {
            showModal("Reconnect Ban", `${id} is now reconnect banned`, "OK");
            userIdToBan = "";
            loadBannedUsers();
        });
    };

    const unbanUser = (id) => {
        SendRequest("ReconnectUnBanUser", "POST", "userId=" + id, () => {
            showModal("Reconnect UnBan", `${id} is now unbanned`, "OK");
            loadBannedUsers();
        });
    };

    const loadBannedUsers = () => {
        SendRequest("GetAllReconnectBannedUsers", "GET", "", (data) => {
            bannedUsers = data;
        });
    };

    // Load initial data
    loadBannedUsers();
</script>

<div class="card">
    <div class="card-header">
        <h3>Ban User Game Reconnect</h3>
    </div>
    <div class="card-body">
        <p>Banned users get GameFinished as soon as they reconnect to a running game.</p>
        <input type="text" placeholder="User ID" bind:value={userIdToBan} class="form-control mb-2"/>
        <button class="btn btn-danger" on:click={banUser}>Ban User</button>
    </div>
</div>

<div class="card mt-3">
    <div class="card-header">
        <h3>Reconnect Banned Users</h3>
    </div>
    <div class="card-body">
        {#if bannedUsers.length > 0}
            <ul class="list-group">
                {#each bannedUsers as user (user.userId)}
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        {user.userId}
                        <button class="btn btn-sm btn-warning" on:click={() => unbanUser(user.userId)}>UnBan</button>
                    </li>
                {/each}
            </ul>
        {:else}
            <p>No users banned.</p>
        {/if}
    </div>
</div>

<style>
    .card {
        margin: 10px 0;
        padding: 10px;
    }
    .mt-3 {
        margin-top: 15px;
    }
</style>
